import { Dayjs } from "dayjs";
import { ICreatedBy, IAttachment } from "../global";
import { ISalesCustomer } from "./index";

export enum VatType {
  NoVat = "no_vat",
  Vat0 = "vat_0",
  Vat7 = "vat_7",
}

export interface IBillingNote {
  id?: number;
  unique_id: string;
  created_date: Dayjs;
  created_by: ICreatedBy | null;
  last_updated_date?: Dayjs;
  last_updated_by?: ICreatedBy | null;
  issue_date: Dayjs;
  due_date: Dayjs;
  credit_day?: number;
  related_user_list: ICreatedBy[];
  company_type: string;
  customer_unique_id: string;
  customer_details: ISalesCustomer | null;
  discount?: number;
  discount_type?: string;
  vat_type?: string;
  withholding_tax_percent?: number;
  pre_discount_amount?: number;
  post_discount_amount?: number;
  vat_exempted_amount?: number;
  vat_0_percent_amount?: number;
  vat_7_percent_amount?: number;
  vat_amount?: number;
  net_amount: number;
  withholding_tax_amount?: number;
  total_amount: number;
  remark?: string;
  main_status?: string;
  sub_status?: string;
  flag_status?: string[];
  aggrid_status?: string;
  accepted_date?: Dayjs;
  accepted_remark?: string;
  attachment_list: IAttachment[];
  item_unique_id_list: string[];
  item_list: IDeliveryTripList[];
  delivery_trip_item_unique_id_list: string[];
  delivery_trip_item_list: IDeliveryTripItemList[];
}

export type IDeliveryTripList = {
  id?: number;
  unique_id: string;
  dt_reference_unique_id: string;
  dt_income_unique_id: string;
  issue_date: Dayjs;
  dt_income_post_discount_amount: number;
  income_post_discount_amount: number;
  income_vat_exempted_amount?: number;
  income_vat_0_percent_amount?: number;
  income_vat_7_percent_amount?: number;
  income_vat_amount?: number;
  income_net_amount?: number;
  dt_income_withholding_tax_amount?: number;
  income_withholding_tax_amount?: number;
  income_total_amount?: number;
  description?: string;
  source_location?: string;
  destination_location?: string;
  vehicle_id: number;
  vehicle_details: IDeliveryTripListVehicleDetails | null;
  aggrid_status?: string;
  customer_details: IDeliverTripListCustomer | null;
  billing_note_id?: number;
  work_list?: any[];
};

export type IDeliveryTripItemList = {
  id?: number;
  unique_id: string;
  dt_unique_id: string;
  dt_job_no: string;
  dt_issue_date: Dayjs;
  dt_vehicle_id: number;
  dt_vehicle_license_plate: string;
  dt_vehicle_type: string;
  // 86d488a5h — snapshot of the trip's fuel price, frozen when the trip is
  // added to the billing note. Optional because documents created before this
  // CR have no value recorded.
  dt_fuel_price?: number;
  dt_aggrid_status: string;
  dt_customer_id: number;
  dt_customer_name: string;
  income_list: {
    income_unique_id: string;
    income_item_unique_id: string;
    income_item_name: string;
    income_item_pre_vat_amount: number;
  }[];
  description: string;
};

export type IDeliverTripListCustomer = {
  name?: string;
  identity_no?: string;
  email?: string;
  phone?: string;
};

export type IDeliveryTripListVehicleDetails = {
  type: string;
  vehicle_no: string;
  license_plate?: string;
};
